import { localizeHref } from '../paraglide/runtime.js';
import { resolveBasepath } from './basepath';

/**
 * The address a browser can be sent to: the locale rewrite plus the mount the build is served
 * under. Anything handed to `window.location` or `redirect({ href })` needs it, the `?to=` and
 * `redirect=` params that round-trip through the BFF included — a `*.path` is the canonical route
 * pattern (`/home`, not `/startseite`), which only router navigation (`redirect({ to })`,
 * `navigate`, `<Link to>`) knows how to rewrite.
 *
 * The primitive `localizedHref` builds on, without the router singleton, so the guards `routeTree`
 * imports can use it too. Idempotent, so a href that is already public survives unchanged.
 */
export function publicHref(href: string): string {
  // Anything but path-relative would come back as an absolute URL with the mount glued in front.
  if (import.meta.env.DEV && !href.startsWith('/')) {
    throw new Error(`publicHref needs a path-relative href, got: ${href}`);
  }
  const mount = resolveBasepath() ?? '';
  const mounted = mount !== '' && (href === mount || href.startsWith(`${mount}/`));
  return `${mount}${localizeHref(mounted ? href.slice(mount.length) || '/' : href)}`;
}
